/**
 * The Ledger icon sizes as inline styles, for icons from `lucide-react`,
 * `react-feather` and `react-icons` (DESIGN-SYSTEM.md, Iconography).
 *
 * Those libraries take a pixel number for `size` and write it into the SVG's
 * `width`/`height` attributes, which cannot read a CSS variable. A style can,
 * and it wins over the attributes: `<Info style={iconSize.sm} />` draws the
 * icon at `--icon-sm` (14px) in dense UI, `md` (16px) in headers and the
 * sidebar, `lg` (20px) as the single icon of an empty state.
 */
const box = (token: string) =>
  ({ width: `var(${token})`, height: `var(${token})` }) as const;

export const iconSize = {
  sm: box("--icon-sm"),
  md: box("--icon-md"),
  lg: box("--icon-lg"),
} as const;
